export const brandName = process.env.LEMLOCK_DOMAIN;
export const apiCms = process.env.REACT_APP_CMS;



// WEBPACK FOOTER //
// ./src/config/constants.js